import PropTypes from 'prop-types';

import { black5 } from '../../../assets/shared-styles/general';

const DocumentStrokedIcon = ({ size = '24', color = black5, isHovered }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill={color}
          fillOpacity={isHovered ? '1' : '.5'}
          fillRule="nonzero"
          d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
        />
      </g>
    </svg>
  );
};

DocumentStrokedIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  isHovered: PropTypes.bool,
};

export default DocumentStrokedIcon;
